import { generateId } from './contentUtils';

const EXPORT_PAYLOAD_REQUEST_EVENT = 'boppps-export-payload-request';
const EXPORT_PAYLOAD_RESPONSE_EVENT = 'boppps-export-payload-response';

export const requestLiveSlideDeckExportPayload = ({ timeoutMs = 30000 } = {}) => {
  if (typeof window === 'undefined') return Promise.resolve(null);

  return new Promise((resolve) => {
    const requestId = generateId();
    let settled = false;

    const finish = (payload) => {
      if (settled) return;
      settled = true;
      window.removeEventListener(EXPORT_PAYLOAD_RESPONSE_EVENT, handleResponse);
      clearTimeout(timer);
      resolve(payload || null);
    };

    const handleResponse = (event) => {
      const detail = event?.detail || {};
      if (detail.requestId !== requestId) return;
      finish(detail.payload || null);
    };

    const timer = setTimeout(() => finish(null), timeoutMs);

    window.addEventListener(EXPORT_PAYLOAD_RESPONSE_EVENT, handleResponse);
    window.dispatchEvent(new CustomEvent(EXPORT_PAYLOAD_REQUEST_EVENT, { detail: { requestId } }));
  });
};

export const registerLiveSlideDeckExportPayloadResponder = (buildPayload) => {
  if (typeof window === 'undefined') return () => {};

  const handleRequest = async (event) => {
    const requestId = event?.detail?.requestId;
    if (!requestId) return;

    let payload = null;
    try {
      payload = await buildPayload();
    } catch {
      payload = null;
    }

    window.dispatchEvent(new CustomEvent(EXPORT_PAYLOAD_RESPONSE_EVENT, {
      detail: { requestId, payload }
    }));
  };

  window.addEventListener(EXPORT_PAYLOAD_REQUEST_EVENT, handleRequest);
  return () => {
    window.removeEventListener(EXPORT_PAYLOAD_REQUEST_EVENT, handleRequest);
  };
};

export const resolveExportPayloadAtClick = async ({
  showSettingsPage,
  buildLocalPayload,
  requestLivePayload = requestLiveSlideDeckExportPayload
}) => {
  if (showSettingsPage) {
    try {
      const localPayload = await buildLocalPayload();
      if (localPayload) return localPayload;
    } catch {
      // Fall back to the live slides instance when local payload generation fails.
    }

    const livePayload = await requestLivePayload();
    if (livePayload) return livePayload;
  }
  return buildLocalPayload();
};
